import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonHelperService } from '../../CommonUtility/common-helper.service';
import { LoanSearchModel, RegistrationRequest } from '../../Models/user-data.model';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import * as CryptoJS from 'crypto-js';
import { LoanPurposeType, PageType } from '../../Models/EnumHelper';
import { GetLoanYears } from '../../CommonUtility/util';
import { environment } from '../../../environments/environment';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';
import { PLATFORM_ID } from '@angular/core';
import { WindowRefService } from '../../../Services/window-ref.service';

@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarComponent,
    FooterComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css']
})
export class HomePageComponent implements OnInit {
  imgSrc = environment.imgBasURL;
  OneForm!: FormGroup;
  QuoteLoanForm!: FormGroup;

  navType: PageType = PageType.home;
  PurposeType: number;
  Amount: number;
  TermTypes: string;
  TermYear: number;
  LoanTermOnSlider: number;
  EmailToSendInvite!: string;
  LoanType: string;
  submitted = false;
  EncryptionText: string = 'publicwebsite-Ooki';
  PurposeTypeEnum = LoanPurposeType;
  QuotePurposeType: number;
  QuoteLoanType: string;
  QuoteAmount: number;
  QuoteTermTypes: string;
  QuoteTermYear: number;
  QuoteLoanTermOnSlider: number = 6;

  @ViewChild('sliderAmount') amountSlider!: ElementRef;
  @ViewChild('sliderMonth') monthSlider!: ElementRef;
  @ViewChild('sliderQuoteAmount') quoteAmountSlider!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _creditGeniusService: CreditGeniusService,
    private _commonHelper: CommonHelperService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    private windowRef: WindowRefService
  ) {
    this.PurposeType = this.QuotePurposeType = this.PurposeTypeEnum.HomeImprovements;
    this.LoanType = this.QuoteLoanType = 'Home Improvements';
    this.Amount = this.QuoteAmount = 500;
    this.TermTypes = this.QuoteTermTypes = 'mths';
    this.TermYear = this.QuoteTermYear = 6;
    this.LoanTermOnSlider = this.QuoteLoanTermOnSlider = 6;
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe(params => {
        const win = this.windowRef.nativeWindow;
        if (win && params?.['tag'] === 'back') {
          const newurl = win.location.protocol + '//' + win.location.host + win.location.pathname;
          win.history.pushState({ path: newurl }, '', newurl);
        }
      });

      const storageData = localStorage.getItem('loanprefrence');
      if (storageData) {
        const storageValue = JSON.parse(storageData);
        if (storageValue) {
          this.PurposeType = this.QuotePurposeType = storageValue.LoanPurpose ?? this.PurposeType;
          this.LoanType = this._commonHelper.GetLoanType(this.PurposeType);
          this.Amount = this.QuoteAmount = storageValue.LoanAmount ?? this.Amount;
          this.LoanTermOnSlider = this.QuoteLoanTermOnSlider = storageValue.LoanTerm ?? this.LoanTermOnSlider;
          this.TermYear = this.QuoteTermYear = this.LoanTermOnSlider >= 12 ? GetLoanYears(this.LoanTermOnSlider) : this.LoanTermOnSlider;
          this.TermTypes = this.QuoteTermTypes = this.LoanTermOnSlider > 12 ? 'yrs' : this.LoanTermOnSlider === 12 ? 'yr' : 'mths';
        }
      }
    }

    this.OneForm = this.fb.group({
      LoanAmount: [this.Amount, [Validators.required, Validators.min(500), Validators.max(25000)]],
      LoanTerm: [this.LoanTermOnSlider, Validators.required]
    });

    this.QuoteLoanForm = this.fb.group({
      QuoteLoanAmount: [this.QuoteAmount, [Validators.required, Validators.min(500), Validators.max(25000)]],
      QuoteLoanTerm: [this.QuoteLoanTermOnSlider, Validators.required]
    });
  }

  get f() {
    return this.OneForm.controls;
  }

  get t() {
    return this.QuoteLoanForm.controls;
  }

  onStarted() {
    this.submitted = true;
    const loanSearchModel: LoanSearchModel = {
      LoanPurpose: this.PurposeType,
      LoanAmount: Number(this.f['LoanAmount'].value),
      LoanTerm: Number(this.f['LoanTerm'].value),
      LoanType: this.LoanType
    };
    localStorage.setItem('loanprefrence', JSON.stringify(loanSearchModel));
    this.router.navigate(['/personal']);
  }

  getLoanQuote() {
    this.submitted = true;
    const loanSearchModel: LoanSearchModel = {
      LoanPurpose: this.QuotePurposeType,
      LoanAmount: Number(this.t['QuoteLoanAmount'].value),
      LoanTerm: Number(this.t['QuoteLoanTerm'].value),
      LoanType: this.QuoteLoanType
    };
    localStorage.setItem('loanprefrence', JSON.stringify(loanSearchModel));
    this.router.navigate(['/personal']);
  }

  LoanPurpose(purpose: number, loanType: string) {
    this.PurposeType = purpose;
    this.LoanType = loanType;
  }

  GetQuoteLoanPurpose(purpose: number, loanType: string) {
    this.QuotePurposeType = purpose;
    this.QuoteLoanType = loanType;
  }

  changeSlider(event: any, control: string) {
    let value = event.target.value;
    if (control === 'LoanAmount') {
      this.Amount = value;
    } else if (control === 'LoanTerm') {
      this.TermTypes = value >= 12 ? (value === 12 ? 'yr' : 'yrs') : 'mths';
      this.TermYear = value >= 12 ? GetLoanYears(value) : value;
    } else if (control === 'QuoteLoanAmount') {
      this.QuoteAmount = value;
    } else if (control === 'QuoteLoanTerm') {
      this.QuoteTermTypes = value >= 12 ? (value === 12 ? 'yr' : 'yrs') : 'mths';
      this.QuoteTermYear = value >= 12 ? GetLoanYears(value) : value;
    }
  }

  LoanAmounts(event: any) {
    let value = parseInt(event.target.value) || 0;
    value = value < 500 ? 500 : value + (250 - (value % 250)) % 250;
    this.Amount = value;
    this.OneForm.controls['LoanAmount'].setValue(value);
    this.amountSlider.nativeElement.value = value;
  }

  LoanQuoteAmounts(event: any) {
    let value = parseInt(event.target.value) || 0;
    value = value < 500 ? 500 : value + (250 - (value % 250)) % 250;
    this.QuoteAmount = value;
    this.QuoteLoanForm.controls['QuoteLoanAmount'].setValue(value);
    this.quoteAmountSlider.nativeElement.value = value;
  }

  registrationRequest() {
    const data: RegistrationRequest = { Username: this.EmailToSendInvite };
    this._creditGeniusService.RegistrationRequest(data).subscribe(
      (result) => {
        if (result.data && result.data.length > 0) {
          const email = encodeURIComponent(CryptoJS.AES.encrypt(this.EmailToSendInvite, this.EncryptionText).toString());
          const ref = encodeURIComponent(CryptoJS.AES.encrypt('public', this.EncryptionText).toString());
          const win = this.windowRef.nativeWindow;
          if (win) {
            win.open(`${result.data}?email=${email}&ref=${ref}`, '_blank');
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.log('Catch exception: ' + err);
      }
    );
  }

  MoveTop() {
    const win = this.windowRef.nativeWindow;
    if (win) {
      win.scroll(0, 0);
    }
  }
}
